import {Injectable, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProductCardUtilService implements OnDestroy {

  private subscriptions: Subscription[] = [];

  constructor() {
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  public unsubscribeAll() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
}
